let Client = {
  get: async function(props){
    const authToken = await localStorage.getItem("token");
    let query_string = props ? `?${new URLSearchParams(props).toString()}`: "";
    let url = `${process.env.REACT_APP_API_BASE_URL}/support/client${query_string}`
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken,
      }),
    });
    const response = await fetch(request);
    const json = await response.json();
    return { data: json.data, total: json.pagination.total };
  },
  create: async function(client) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(client)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  update: async function(uuid, client) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        }),
        body: JSON.stringify(client)
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  delete: async function(uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken
        })
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  load: async function(uuid) {
    const authToken = await localStorage.getItem("token");
    var url = `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}`;
    const request = new Request(url, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: authToken
      })
    });
    const response = await fetch(request);
    const json = await response.json();
    return json;
  },
  enableSync: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/enable-sync`,
      {
        method: "PATCH",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ uuid }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  disableSync: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/disable-sync`,
      {
        method: "PATCH",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ uuid }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  updateContacts: async function (uuid, contacts) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/contacts`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ contacts }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  listCloudUsers: async function (client_uuid, params) {
    const authToken = await localStorage.getItem("token");
    const query_string = params ? `?${new URLSearchParams(params).toString()}` : "";
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users${query_string}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  listEvents: async function (client_uuid, params) {
    const authToken = await localStorage.getItem("token");
    const query_string = params ? `?${new URLSearchParams(params).toString()}` : "";
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/events${query_string}`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  createCloudUser: async function (client_uuid, user) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify(user),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  updateCloudUser: async function (client_uuid, uuid, user) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users/${uuid}`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify(user),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  deleteCloudUser: async function (client_uuid, uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users/${uuid}`,
      {
        method: "DELETE",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  syncToServiceNow: async function (uuid, createServiceTicket) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/servicenow-sync`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ create_service_ticket: !!createServiceTicket }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  getServiceNowInfo: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/servicenow-info`,
      {
        method: "GET",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  sendCloudUpgradeEmail: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/send-cloud-upgrade-email`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  sendCloudUsersForm: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/cloud-users-form/send`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  sendCloudCredentials: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/cloud-users/send-credentials`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  sendCloudUserCredentials: async function (client_uuid, cloud_user_uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users/${cloud_user_uuid}/send-credentials`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  setCloudUserPassword: async function (client_uuid, cloud_user_uuid, temp_password) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users/${cloud_user_uuid}/set-password`,
      {
        method: "PUT",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ temp_password }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  resetCloudUserPassword: async function (client_uuid, cloud_user_uuid, skip_citrix_reset) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${client_uuid}/cloud-users/${cloud_user_uuid}/reset-password`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
        body: JSON.stringify({ skip_citrix_reset }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
  submitLicenseToZimcom: async function (uuid) {
    const authToken = await localStorage.getItem("token");
    const request = new Request(
      `${process.env.REACT_APP_API_BASE_URL}/support/client/${uuid}/submit-license-to-zimcom`,
      {
        method: "POST",
        headers: new Headers({
          "Content-Type": "application/json",
          Authorization: authToken,
        }),
      }
    );
    const response = await fetch(request);
    return await response.json();
  },
};
export default Client;